import { Subject } from "rxjs";
import { MealType } from "./Meal";

export class LastTrackerUsed {
    private overall: TrackerKind | undefined;
    private mealTypes: MealTypeItem[] = [];

    public changedSubject: Subject<boolean> = new Subject<boolean>();

    constructor(i?: ILastTrackerUsed) {
        if(i) {
            this.overall = i.overall;
            this.mealTypes = i.mealTypes;
        }
    }

    public get(mealType?: MealType): TrackerKind | undefined {
        if(mealType == undefined) return this.overall;
        var ret = this.mealTypes.find(m => m.mealType == mealType);
        if(!ret) return this.overall;
        return ret.trackerKind;
    }

    public set(tracker: TrackerKind, mealType: MealType): void {
        this.overall = tracker;
        var index = this.mealTypes.findIndex(m => m.mealType == mealType);
        if(index == -1) {
            this.mealTypes.push({mealType: mealType, trackerKind: tracker});
            this.changedSubject.next(true);
            return;
        }
        this.mealTypes[index].trackerKind = tracker;
        this.changedSubject.next(true);
    }
    
    public toInterface(): ILastTrackerUsed {
        return {overall: this.overall, mealTypes: this.mealTypes};
    }
}

export interface ILastTrackerUsed {
    overall: TrackerKind | undefined;
    mealTypes: MealTypeItem[];
}

interface MealTypeItem {
    mealType: MealType;
    trackerKind: TrackerKind;
}

export enum TrackerKind {
    detailed, fast
}